if (!customElements.get('gallery-zoom-open')) {
  class GalleryZoomOpen extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    /**
     * Handle a click event.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const mediaGallery = this.closest('media-gallery');
      const zoomDevice = mediaGallery.dataset.zoomEnabled;

      if (zoomDevice.length === 0 || (zoomDevice === 'mobile' && !theme.mediaMatches.md) || (zoomDevice === 'desktop' && theme.mediaMatches.md)) {
        // Add to document on first open
        if (!mediaGallery.galleryModal.parentElement) {
          document.body.appendChild(mediaGallery.galleryModal);
        }

        mediaGallery.galleryModal.open(evt.currentTarget);
        const zoom = mediaGallery.galleryModal.querySelector('gallery-zoom');
        zoom.init(evt.currentTarget.parentElement.dataset.mediaId);

        evt.preventDefault();
      }
    }
  }

  window.customElements.define('gallery-zoom-open', GalleryZoomOpen);
}

/* eslint-disable max-len */

if (!customElements.get('gallery-zoom')) {
  class GalleryZoom extends HTMLElement {
    connectedCallback() {
      if (!this.initialised) {
        this.initialised = true;     
         this.zoomContainer = this.querySelector('[data-swiper-custom]') || null;
         this.zoomContainer_get =  this.getAttribute('data-slider-options') || null; 
         this.zoomContainer_get_json =JSON.parse(this.zoomContainer_get);
      }
    }

    init(currentMediaId) {
      console.log("this.thumbSlider",this.zoomContainer,currentMediaId);

      
      if(!this.zoomContainer) return;
      var main_con_pdp = this.zoomContainer.swiper || false;
      const main_index = this.zoomContainer.querySelector('[data-media-id = "'+currentMediaId+'"]') || null;
      if(main_con_pdp && main_index){
              main_con_pdp.slideTo(main_index.getAttribute('data-swiper-slide-id'), 500, false);
      }else{
         var main_con_pdp =  new Swiper(this.zoomContainer, this.zoomContainer_get_json);
         main_con_pdp.slideTo(main_index.getAttribute('data-swiper-slide-id'), 500, false);
      }
    }

  }

  window.customElements.define('gallery-zoom', GalleryZoom);
}
